<template>
<div class="chapter">
<div class="inner_page">
<section epub:type="chapter" id="ch5" title="Why Do Thunderstorms Set Off Car Alarms?">
<p class="h2a"><a href="#/text/Contents#rch5">Why Do Thunderstorms Set Off Car Alarms?</a></p>
<figure>
<p class="image"><img alt="" height="193" src="images/f010.jpg" width="159"/></p>
</figure>
<p class="noindent1">In violent thunderstorms, it is not uncommon to hear a number of car alarms sounding. This is because thunder produces shock waves that travel through the air to the ground.</p>
<p class="indent">Modern car alarm systems use instruments to detect shock, pressure, and motion. These detectors monitor for vibrations using a microphone or the car stereo speakers to pick up low-frequency sounds.</p>
<p class="indent"><span class="right_1" epub:type="pagebreak" id="page_11" title="11">The shock waves produced from thunder can set off car alarms in one of two ways. They can shake the ground and the car, which sets off the motion sensors, similar to when a person breaking into a car shakes it and sets off the alarm. Or, the shock waves can cause a change in air pressure, which physically moves the speakers. The speakers then produce an electrical signal that triggers the alarm.</span></p>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Chapter005.vue?4acf32c6